module.exports = "div.usersCard {\n  margin-top: 0em; }\n\n.newUser {\n  margin-top: -40px;\n  margin-right: 7px;\n  float: right; }\n"